var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"no-data"}},[_vm._t("img",[_c('img',{attrs:{"src":require("@/assets/img/icon/no_data.png"),"alt":""}})]),_vm._t("text",[_c('p',[_vm._v(_vm._s(_vm.title ? _vm.title : "暂无相关数据"))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }